var $ = require("jquery");

jQuery(function () {

    // form phone consent
    let addAnotherService = $('#add-another-service');

    addAnotherService.on('click', function () {
        let widgetCommentSelect = $('.widget-comment-select').first().clone();
        let widgetCommentComment = $('.widget-comment-comment').first().clone();
        widgetCommentComment.find('textarea').val('');
        let widgetClearComment = $('.clear-comment').first().clone();
        $('#comment-container').append(widgetCommentSelect, widgetCommentComment, widgetClearComment);
        return false;
    });

    $('#review-form').on('submit', function (ev) {
        // Prevent the form from actually submitting
        ev.preventDefault();
        let loadingSpin = $(document).find('.loadingsvg').clone();
        $('#review-response').html(loadingSpin).fadeIn();
        $('#review-submit-btn').attr('disabled', 'disabled');
        const formData = new FormData(ev.target);
        let services = formData.getAll('service');
        let comments = formData.getAll('comment');
        if (comments.length === 1 && comments[0] === '') {
            // no comment input
        } else {
            let comment = '';
            for (const [i, service] of services.entries()) {
                comment += ' |' + service + ': ' + comments[i] + ' |'
            }
            formData.set('comment', comment);
            formData.delete('service');
        }

        // for(var pair of formData.entries()) {
        //     console.log(pair[0]+ ', '+ pair[1]);
        // }
        $.ajax({
            url: '/wheelform/message/send',
            data: formData,
            processData: false,
            contentType: false,
            method: 'POST',
            success: function (response) {
                if (response.success) {
                    resp = response.message;

                    $('#review-response').empty().html('<p class="form-thanks">' + resp + '</p>').fadeIn();
                    // empty form
                    $('#review-form')[0].reset();
                    // analytics event form
                    if (typeof gtag === 'function') {
                        gtag('event', 'generate_lead', {
                            'event_category': 'form',
                            'event_action': 'send',
                            'event_label': 'review'
                        });
                    }
                    $('#review-submit-btn').removeAttr('disabled');
                } else {
                    // response.values will contain user submitted values
                    // response.errors will be an array containing any validation errors that occurred, indexed by field name
                    // e.g. response.error['email'] => ['Email is required', 'Email is invalid']
                    var errors = jQuery.map(response.errors, function (a) {
                        return a[0];
                    });
                    $('#review-response').empty().html('<p class="form-errors">Attenzione:<br> ' + errors.join("<br>") + '</p>').fadeIn();
                    $('#review-submit-btn').removeAttr('disabled');
                }
            }
        });
    });
});